import { pipe } from 'fp-ts/lib/function';
import type { ExistingVendor } from '../vendorTypes';
import { deleteUnsavedAttribute } from './deleteUnsavedAttribute';
import { deleteVendorApiTemporaryAttributes } from './deleteVendorsApiTemporaryAttributes';
import { updateVendorForRequest } from './updateVendorForRequest';

export const transformVendorsForRequest = (vendors: ExistingVendor[]) =>
  pipe(
    vendors,
    (vendorList) => vendorList.map(deleteVendorApiTemporaryAttributes),
    (vendorList) => vendorList.map(deleteUnsavedAttribute),
    (vendorList) => vendorList.map((vendor) => updateVendorForRequest(vendor)),
  );
